import { render, staticRenderFns } from "./MarketerList.vue?vue&type=template&id=5c5af1f6&scoped=true"
import script from "./MarketerList.vue?vue&type=script&lang=js"
export * from "./MarketerList.vue?vue&type=script&lang=js"
import style0 from "./MarketerList.vue?vue&type=style&index=0&id=5c5af1f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5af1f6",
  null
  
)

export default component.exports